<template>
  <div id="app">
    <SiteHeader />
    <main id="main">
      <router-view :key="$route.fullPath" />
    </main>
    <SiteFooter />
    <router-link class="float-contact" to="/contact" :aria-label="$t('common.consult')">
      ↗<span>{{ $t('common.consult') }}</span>
    </router-link>
    <button class="back-top" type="button" :aria-label="$t('common.backTop')" :hidden="!showBackTop" @click="backTop">↑</button>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return { showBackTop: false }
  },
  mounted() {
    window.addEventListener('scroll', this.updateBackTop, { passive: true })
    this.updateBackTop()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateBackTop)
  },
  watch: {
    $route() {
      window.scrollTo({ top: 0, behavior: 'auto' })
    },
    '$i18n.locale'() {
      this.updateTitle()
    }
  },
  methods: {
    updateBackTop() {
      this.showBackTop = window.scrollY > 500
    },
    backTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    updateTitle() {
      const key = { home: 'home', about: 'about', solutions: 'solutions', products: 'products', cases: 'cases', service: 'service', resources: 'resources', contact: 'contact', detail: 'detail', 'article-design': 'article' }[this.$route.name] || 'missing'
      document.title = `${this.$t(`routes.${key}`)} | ${this.$t('routes.suffix')}`
    }
  }
}
</script>
